import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function initLogosCarouselContact(): void {
    const $logosCarouselContactContainer = document.querySelectorAll('.js-logos-slider-contact');

    $logosCarouselContactContainer.forEach($container => {
        new LogosCarouselContact($container as HTMLElement);
    });
}

class LogosCarouselContact {
    $el: HTMLElement;
    swiper: Swiper | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (!this.$el) return;

        const $wrapper = this.$el.querySelector('.swiper-wrapper');
        const $slides = Array.from(this.$el.querySelectorAll('.swiper-slide'));

        // Nombre minimum de slides requis pour loop = slidesPerView + 1 (au moins)
        const minSlidesNeeded = 5;
        if ($slides.length > 0 && $slides.length < minSlidesNeeded && $wrapper) {
            const clonesNeeded = minSlidesNeeded - $slides.length;
            for (let i = 0; i < clonesNeeded; i++) {
                const clone = $slides[i % $slides.length].cloneNode(true);
                $wrapper.appendChild(clone);
            }
        }

        this.swiper = new Swiper(this.$el, {
            modules: [Autoplay],
            slidesPerView: 4,
            loop: true,
            speed: 6000,
            spaceBetween: 40,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            allowTouchMove: false,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                0: {
                    slidesPerView: 3,
                },
            },
        });
    }
}
